/* eslint-disable jsx-a11y/no-access-key */
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { toast } from 'react-toastify';
import PropTypes from 'prop-types';

import ButtonSp from '../../components/ButtonSp';

import InputTextSp from '../../components/InputTextSp';
import LabelSp from '../../components/LabelSp';
import { showMessage } from '../../components/MessageDialog';

import ChamadoService from '../../services/ChamadoService';
import { ChamadoModel } from '../../util/Models';

import {
  cloneObj,
  errorHandle,
  formatDate,
  isDate,
  strToDate,
  validateFields,
} from '../../util/functions';

import { StateScreen } from '../constants';
import DropdownSp from '../../components/DropdownSp';

import InputTextareaSp from '../../components/InputTextareaSp';

import DropDownLazy from '../../components/DropdownLazy';
import CalendarSp from '../../components/CalendarSp';
import AuthService from '../../services/AuthService';
import RevendaService from '../../services/RevendaService';
import ClienteService from '../../services/ClienteService';
import { store } from '../../store';
import { showLookup } from '../../store/modules/dialog/actions';

import ColaboradorService from '../../services/ColaboradorService';
import ChamadoTipoService from '../../services/ChamadoTipoService';
import { cfgPtBr } from '../../config/Constantes';
import ListBoxSp from '../../components/ListBoxSp';
import LookupClassificacaoAt from '../../components/LookupClassificacaoAt';
import AtendClassificacaoService from '../../services/AtendClassificacaoService';
import MessageInputText from '../../components/MessageInputText';
import SelectButtons from '../../components/SelectButtons';
import history from '../../services/history';
import CrudAnexo from './crudAnexo';
import DialogSp from '../../components/DialogSp';

function ChamadoCrud(props) {
  ChamadoCrud.propTypes = {
    stateScreen: PropTypes.string.isRequired,
    idSelected: PropTypes.number.isRequired,
    onClose: PropTypes.func.isRequired,
    closeOnSaveCancel: PropTypes.bool,
  };

  ChamadoCrud.defaultProps = {
    messageConfirmation: 'Confirma os dados',
    showConfirmation: false,
    closeOnSaveCancel: false,
  };
  const txtContatoRef = useRef();
  const txtButtonRef = useRef();

  const { stateScreen, idSelected, onClose, closeOnSaveCancel, toBack } = props;

  const revendaUsuario = AuthService.getUsuario().revenda
    ? {
        label: AuthService.getUsuario().revenda.nome,
        value: AuthService.getUsuario().revenda.id,
      }
    : {
        label: 'Speedy',
        value: 1,
      };

  const colaboradorUsuario = AuthService.getUsuario().colaborador
    ? {
        label: AuthService.getUsuario().colaborador.nome,
        value: AuthService.getUsuario().colaborador.id,
      }
    : null;

  let eBack = '';
  let uBack = '';
  if (toBack) {
    eBack = `&toBack=${toBack}`;
    uBack = `?toBack=${toBack}`;
  }

  // states
  const [chamado, setChamado] = useState(new ChamadoModel());
  const [revendaSelecionada, setRevendaSelecionada] = useState(revendaUsuario);
  const [errorLoadRecord, setErrorLoadRecord] = useState(false);
  const [chamadoTipos, setChamadoTipos] = useState([]);
  const [chamadoTiposTransferencia, setChamadoTiposTransferencia] = useState([]);

  const [colaboradorSelecionado, setColaboradorSelecionado] = useState();
  const [classificacaoSelecionada, setClassificacaoSelecionada] = useState();
  const [classificacoesSelecionadas, setClassificacoesSelecionadas] = useState([]);
  const [paginaSelecionada, setPaginaSelecionada] = useState(0);
  const [lookupTopicoVisible, setLookupTopicoVisible] = useState(false);
  const [messageVisibleAlterarDescricao, setMessageVisibleAlterarDescricao] = useState(false);
  const [idChamadoTipoTransferencia, setIdChamadoTipoTransferencia] = useState();
  const [showTransferencia, setShowTransferencia] = useState(false);
  const [clienteFone, setClienteFone] = useState('');
  const [clienteCelular, setClienteCelular] = useState('');
  const [idColaboradorTransferencia, setIdColaboradorTransferencia] = useState();
  const [colaboradoresTransferencia, setColaboradoresTransferencia] = useState([]);

  // useCallbacks

  const loadRecord = useCallback(async _id => {
    try {
      const retorno = await ChamadoService.findById(_id);

      const revenda = retorno.revenda
        ? {
            label: retorno.revenda.nome,
            value: retorno.revenda.id,
          }
        : null;

      const colaborador = retorno.colaborador
        ? {
            label: retorno.colaborador.nome,
            value: retorno.colaborador.id,
          }
        : null;

      if (isDate(retorno.dataLancamento)) {
        retorno.horaLancamento = strToDate(
          `${retorno.dataLancamento} ${retorno.horaLancamento}`,
          'yyyy-MM-dd HH:mm:ss'
        );

        retorno.dataLancamento = strToDate(retorno.dataLancamento);
      }

      if (isDate(retorno.dataFechamento)) {
        retorno.horaFechamento = strToDate(
          `${retorno.dataFechamento} ${retorno.horaFechamento}`,
          'yyyy-MM-dd HH:mm:ss'
        );

        retorno.dataFechamento = strToDate(retorno.dataFechamento);
      }

      if (isDate(retorno.dataFimContrato)) {
        retorno.dataFimContrato = strToDate(retorno.dataFimContrato);
      }

      setRevendaSelecionada(revenda);
      setChamado(retorno);
      setColaboradorSelecionado(colaborador);
      // telefones do clientes
      const { clienteContatoEndereco } = retorno.cliente;
      if (clienteContatoEndereco) {
        setClienteFone(clienteContatoEndereco.fone);
        setClienteCelular(clienteContatoEndereco.celular);
      }

      // classificação
      const { chamadoClassificacao } = retorno;
      if (Array.isArray(chamadoClassificacao)) {
        const classificacoes = chamadoClassificacao.map(e => {
          return {
            id: e.idAtendClassificacao,
            descricao: e.descricao,
          };
        });
        setClassificacoesSelecionadas([...classificacoes]);
      }

      setErrorLoadRecord(false);
    } catch (err) {
      setErrorLoadRecord(true);
      errorHandle(err);
    }
  }, []);

  const loadColaborador = useCallback(async _nome => {
    if (_nome !== undefined) {
      const r = await ColaboradorService.findAll({
        nome: _nome,
        limit: 999,
      });

      const retorno = r.items.map(e => {
        return {
          label: e.nome,
          value: e.id,
        };
      });
      return retorno;
    }
    return [];
  }, []);

  const loadResponsaveisTransferencia = useCallback(async () => {
    const ret = await loadColaborador('');
    setColaboradoresTransferencia(ret);
  }, [loadColaborador]);

  const lookupCliente = () => {
    const { dispatch } = store;
    const lookupConfig = ClienteService.getLookupConfig(
      objReturn => {
        const { id, nome, fone, celular, nomeContato, numeroContrato } = objReturn;

        const cliente = {
          id,
          nome,
          numeroContrato,
        };

        setChamado({
          ...chamado,
          cliente,
          idCliente: cliente.id,
          contato: nomeContato || chamado.contato,
        });
        setClienteFone(fone);
        setClienteCelular(celular);
        if (
          txtContatoRef.current &&
          txtContatoRef.current.element &&
          txtContatoRef.current.element.focus
        ) {
          setTimeout(() => txtContatoRef.current.element.focus(), 200);
        }
      },
      () => {
        if (
          txtButtonRef.current &&
          txtButtonRef.current.element &&
          txtButtonRef.current.element.focus
        ) {
          setTimeout(() => txtButtonRef.current.element.focus(), 200);
        }
      }
    );

    dispatch(showLookup(lookupConfig));
  };

  const loadRevenda = useCallback(async _nome => {
    if (_nome !== undefined) {
      const r = await RevendaService.findAll({ nome: _nome, limit: 50 });

      const retorno = r.items.map(e => {
        return {
          label: e.nome,
          value: e.id,
        };
      });
      return retorno;
    }
    return [];
  }, []);

  const loadChamadoTipo = useCallback(async () => {
    const r = await ChamadoTipoService.findAll({ limit: 999 });

    const retorno = r.items.map(e => {
      return {
        label: e.nome,
        value: e,
      };
    });

    setChamadoTipos(retorno);
    const permiteTransferencia = r.items
      .filter(e => e.permiteTransferencia === true)
      .map(e => {
        return {
          label: e.nome,
          value: e.id,
        };
      });

    setChamadoTiposTransferencia(permiteTransferencia);
  }, []);

  // funcoes
  function viewMode() {
    return stateScreen === StateScreen.stView || errorLoadRecord;
  }

  function bloqueiaRevenda() {
    return AuthService.getUsuario().idRevenda && !AuthService.isPerfilGerente();
  }

  const salvaClassificacao = useCallback(
    reg => {
      if (classificacoesSelecionadas && classificacoesSelecionadas.length > 0) {
        const classificacaoExist = classificacoesSelecionadas.find(e => e.id === reg.id);

        if (classificacaoExist) {
          toast.warn('Classificação já existe');
          return;
        }
      }
      setClassificacoesSelecionadas([
        ...classificacoesSelecionadas,
        { descricao: reg.descricao, id: reg.id },
      ]);
    },
    [classificacoesSelecionadas]
  );

  const alteraDescricao = useCallback(async () => {
    if (classificacoesSelecionadas && classificacoesSelecionadas.length > 0) {
      const classificacaoExist = classificacoesSelecionadas.find(
        e => e.id === classificacaoSelecionada
      );

      if (!classificacaoExist) {
        toast.warn('Classificação não encontrada');
        return;
      }

      // verifica se a classificacao permite alterar descricao
      const ret = await AtendClassificacaoService.findById(classificacaoSelecionada);
      if (ret.permiteAlterarDescricao) {
        setMessageVisibleAlterarDescricao(true);
      } else {
        toast.warn('Classificação não permite alterar descricao');
      }
    }
    // setClassificacoesSelecionadas([...classificacoesSelecionadas]);
  }, [classificacaoSelecionada, classificacoesSelecionadas]);

  function handleBack() {
    if (stateScreen === StateScreen.stView) {
      onClose();
    } else {
      showMessage('Confirmação', 'Abandonar mudanças?', idx => {
        if (idx === 1) {
          if (stateScreen === StateScreen.stInsert || closeOnSaveCancel) {
            onClose();
          } else {
            history.push(`/chamados/${idSelected}?view${eBack}`);
          }
        }
      });
    }
  }

  function handleSave() {
    if (stateScreen === StateScreen.stView) {
      onClose();
    } else if (!chamado.idChamado && chamado.status === 4) {
      setShowTransferencia(true);
    } else {
      salvarRecord();
    }
  }

  async function salvarRecord() {
    try {
      let retorno;
      const chamadoSalvar = cloneObj(chamado);
      if (chamadoSalvar.horaFechamento) {
        chamadoSalvar.horaFechamento = formatDate(chamadoSalvar.horaFechamento, 'HH:mm');
      }
      if (chamadoSalvar.horaLancamento) {
        chamadoSalvar.horaLancamento = formatDate(chamadoSalvar.horaLancamento, 'HH:mm');
      }

      chamadoSalvar.chamadoClassificacao = [];
      if (classificacoesSelecionadas.length > 0) {
        classificacoesSelecionadas.forEach(e => {
          const chamadoClassificacaoExists = (chamado.chamadoClassificacao || []).find(
            e1 => e1.idAtendClassificacao === e.id
          );
          chamadoSalvar.chamadoClassificacao.push({
            id: chamadoClassificacaoExists?.id || undefined,
            idChamado: idSelected || undefined,
            idAtendClassificacao: e.id,
            descricao: e.descricao,
          });
        });
      }

      if (idChamadoTipoTransferencia) {
        chamadoSalvar.idChamadoTipoTransferencia = idChamadoTipoTransferencia;
        chamadoSalvar.idColaboradorTransferencia = idColaboradorTransferencia;
      }

      if (stateScreen === StateScreen.stInsert) {
        retorno = await ChamadoService.insert(chamadoSalvar);
      } else {
        retorno = await ChamadoService.update(chamadoSalvar);
      }
      toast.success('Registro salvo com sucesso.');
      if (closeOnSaveCancel) {
        onClose(retorno);
      } else {
        history.push(`/chamados/${retorno.id}?view${eBack}`);
      }
    } catch (err) {
      errorHandle(err);
    }
  }

  // useEffects
  useEffect(() => {
    loadResponsaveisTransferencia();
    if (stateScreen === StateScreen.stUpdate || stateScreen === StateScreen.stView) {
      loadRecord(idSelected);
    } else if (stateScreen === StateScreen.stInsert) {
      const newChamado = async () => {
        const chamadoTipoSuporte = await ChamadoTipoService.findById(1);
        const novo = new ChamadoModel();
        novo.idUsuario = AuthService.getUsuario().id;
        novo.usuario = AuthService.getUsuario();

        novo.idRevenda = revendaUsuario.value;
        novo.revenda = { id: revendaUsuario.value, nome: revendaUsuario.label };

        novo.chamadoTipo = chamadoTipoSuporte;
        novo.idChamadoTipo = chamadoTipoSuporte.id;
        novo.prazoDias = chamadoTipoSuporte.prazoDias;

        setRevendaSelecionada(revendaUsuario);

        setChamado(novo);
      };
      newChamado();
    }
    loadChamadoTipo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loadRecord, idSelected, stateScreen, loadChamadoTipo]);

  const renderCadastro = () => {
    return (
      <>
        {showTransferencia ? (
          <DialogSp
            visible={showTransferencia}
            setVisible={setShowTransferencia}
            title="Transferência de chamado"
            contentStyle={{ minHeight: 150 }}
            body={
              <div className="p-grid">
                <div className="p-col-12 p-md-12 p-lg-12 p-fluid">
                  <LabelSp>Chamado Tipo</LabelSp>
                  <DropdownSp
                    appendTo={document.body}
                    options={chamadoTiposTransferencia}
                    placeholder="Selecione"
                    required
                    value={idChamadoTipoTransferencia}
                    onChange={e => {
                      setIdChamadoTipoTransferencia(e.target.value);
                    }}
                  />
                </div>

                <div className="p-col-12 p-md-12 p-lg-12 p-fluid">
                  <LabelSp>Responsável</LabelSp>
                  <DropdownSp
                    appendTo={document.body}
                    showClear
                    filter
                    options={colaboradoresTransferencia}
                    value={idColaboradorTransferencia}
                    placeholder="Não definido"
                    onChange={e => {
                      setIdColaboradorTransferencia(e.target.value);
                    }}
                  />
                </div>
              </div>
            }
            handleClose={value => {
              if (value === 1) {
                if (!idChamadoTipoTransferencia) {
                  toast.error('Informe o tipo de chamado para transferir');
                  return;
                }
                if (idChamadoTipoTransferencia === chamado.chamadoTipo.id) {
                  toast.error('Tipo de chamado deve ser diferente do atual');
                  return;
                }
                setShowTransferencia(false);
                salvarRecord();
              }
            }}
          />
        ) : null}
        {lookupTopicoVisible ? (
          <LookupClassificacaoAt
            clickOnConfirm
            handleCancel={setLookupTopicoVisible}
            handleConfirm={ret => {
              salvaClassificacao(ret);
              setLookupTopicoVisible(false);
            }}
            lookupVisible={lookupTopicoVisible}
          />
        ) : null}
        {messageVisibleAlterarDescricao ? (
          <MessageInputText
            title="Informe a descrição"
            caption="Descrição"
            messageVisible={messageVisibleAlterarDescricao}
            handleOk={texto => {
              const classificacaoExist = classificacoesSelecionadas.find(
                e => e.id === classificacaoSelecionada
              );

              if (!classificacaoExist) {
                toast.warn('Classificação não encontrada');
                return;
              }
              classificacaoExist.descricao = texto;

              setClassificacoesSelecionadas([...classificacoesSelecionadas]);
              setMessageVisibleAlterarDescricao(false);
            }}
            handleClose={() => setMessageVisibleAlterarDescricao(false)}
          />
        ) : null}

        <div className="p-col-6 p-md-2 p-lg-2 p-fluid">
          <LabelSp>Data</LabelSp>
          <CalendarSp
            showOnFocus={false}
            showIcon
            required
            locale={cfgPtBr}
            dateFormat="dd/mm/yy"
            disabled={viewMode() || !AuthService.isPerfilGerente()}
            value={chamado.dataLancamento}
            appendTo={window.body}
            onChange={e => {
              setChamado({
                ...chamado,
                dataLancamento: e.target.value,
              });
            }}
          />
        </div>
        <div className="p-col-6 p-md-2 p-lg-2 p-fluid">
          <LabelSp>Hora</LabelSp>
          <CalendarSp
            showOnFocus={false}
            showIcon
            required
            timeOnly
            hourFormat="24"
            disabled={viewMode()}
            value={chamado.horaLancamento}
            appendTo={window.body}
            onChange={e => {
              setChamado({
                ...chamado,
                horaLancamento: e.target.value,
              });
            }}
          />
        </div>
        <div className="p-col-12 p-md-4 p-lg-4 p-fluid">
          <LabelSp>Usuário</LabelSp>
          <InputTextSp value={chamado.usuario?.login.toUpperCase() || ''} disabled />
        </div>
        <div className="p-col-12 p-md-4 p-lg-4 p-fluid">
          <LabelSp>Revenda</LabelSp>
          <DropDownLazy
            autoLoad
            placeholder="Selecione"
            required
            value={revendaSelecionada}
            onChange={e => {
              const revenda = e ? { id: e.value, nome: e.label } : null;
              setChamado({
                ...chamado,
                revenda,
                idRevenda: e?.value,
              });
            }}
            onFilter={async txtFilter => {
              const retorno = await loadRevenda(txtFilter);
              return retorno;
            }}
            disabled={viewMode() || bloqueiaRevenda()}
          />
        </div>
        <div className="p-col-12 p-md-4 p-lg-4 p-fluid">
          <LabelSp>Solicitado por</LabelSp>
          <DropdownSp
            options={[
              { value: 1, label: 'Cliente' },
              { value: 2, label: 'Revenda' },
              { value: 3, label: 'Contabilidade' },
              { value: 4, label: 'Consultor' },
              { value: 99, label: 'Outros' },
            ]}
            disabled={viewMode()}
            placeholder="Selecione"
            required
            value={chamado.solicitadoPor}
            onChange={e => {
              setChamado({
                ...chamado,
                solicitadoPor: e.target.value,
              });
            }}
          />
        </div>
        <div className="p-col-12 p-md-3 p-lg-3 p-fluid">
          <LabelSp>Tipo Chamado</LabelSp>
          <DropdownSp
            options={chamadoTipos}
            disabled={viewMode()}
            placeholder="Selecione"
            required
            value={chamado.chamadoTipo}
            onChange={e => {
              const { prazoDias } = e.target.value;
              setChamado({
                ...chamado,
                prazoDias,
                idChamadoTipo: e.target.value.id,
                chamadoTipo: e.target.value,
              });
            }}
          />
        </div>
        <div className="p-col-12 p-md-2 p-lg-2 p-fluid">
          <LabelSp>Prazo(dias)</LabelSp>
          <InputTextSp value={chamado.prazoDias} disabled />
        </div>
        <div className="p-col-12 p-md-3 p-lg-3 p-fluid">
          <LabelSp>Status</LabelSp>
          <DropdownSp
            options={[
              { value: 0, label: 'Aberto' },
              { value: 1, label: 'Em Andamento' },
              { value: 2, label: 'Fechado' },
              { value: 3, label: 'Cancelado' },
              { value: 4, label: 'Transferido' },
            ]}
            disabled={viewMode() || !!chamado.idChamado}
            placeholder="Selecione"
            required
            value={chamado.status}
            onChange={e => {
              let {
                horaFechamento,
                dataFechamento,
                observacaoAtendente,
                idColaborador,
                colaborador,
              } = chamado;

              if (e.target.value !== 2 && e.target.value !== 4) {
                horaFechamento = null;
                dataFechamento = null;
                if (e.target.value === 0) {
                  observacaoAtendente = '';
                }
              } else {
                if (!horaFechamento) {
                  horaFechamento = new Date();
                }
                if (!dataFechamento) {
                  dataFechamento = new Date();
                }
              }

              if (e.target.value === 0) {
                idColaborador = null;
                colaborador = null;
                setColaboradorSelecionado(null);
              } else if (colaboradorUsuario) {
                idColaborador = colaboradorUsuario.value;
                colaborador = { id: colaboradorUsuario.id, nome: colaboradorUsuario.nome };
                if (!colaboradorSelecionado) {
                  setColaboradorSelecionado(colaboradorUsuario);
                }
              }

              setChamado({
                ...chamado,
                horaFechamento,
                dataFechamento,
                observacaoAtendente,
                idColaborador,
                colaborador,
                status: e.target.value,
              });
            }}
          />
        </div>
        <div className="p-col-6 p-md-2 p-lg-2 p-fluid">
          <LabelSp>Fechamento</LabelSp>
          <CalendarSp
            showOnFocus={false}
            showIcon
            required
            locale={cfgPtBr}
            dateFormat="dd/mm/yy"
            disabled={viewMode() || (chamado.status !== 2 && chamado.status !== 4)}
            value={chamado.dataFechamento}
            appendTo={window.body}
            onChange={e => {
              setChamado({
                ...chamado,
                dataFechamento: e.target.value,
              });
            }}
          />
        </div>
        <div className="p-col-6 p-md-2 p-lg-2 p-fluid">
          <LabelSp>Hora</LabelSp>
          <CalendarSp
            showOnFocus={false}
            showIcon
            required
            timeOnly
            hourFormat="24"
            disabled={viewMode() || (chamado.status !== 2 && chamado.status !== 4)}
            value={chamado.horaFechamento}
            appendTo={window.body}
            onChange={e => {
              setChamado({
                ...chamado,
                horaFechamento: e.target.value,
              });
            }}
          />
        </div>
        <div className="p-col-6 p-md-3 p-lg-3 p-fluid">
          <LabelSp>Responsável</LabelSp>
          <DropDownLazy
            autoLoad
            required={chamado.status !== 0}
            disabled={viewMode()}
            placeholder="Selecione"
            onChange={e => {
              const colaborador = e ? { id: e.value, nome: e.label } : null;
              setColaboradorSelecionado(e);
              setChamado({ ...chamado, colaborador, idColaborador: e?.value });
            }}
            value={colaboradorSelecionado}
            onFilter={async txtFilter => {
              const retorno = await loadColaborador(txtFilter);
              return retorno;
            }}
          />
        </div>
        <div className="p-col-12 p-md-5 p-lg-5 p-fluid">
          <LabelSp>Cliente</LabelSp>
          <div className="p-inputgroup">
            <ButtonSp
              ref={txtButtonRef}
              autoFocus
              type="button"
              icon="pi pi-search"
              className="p-button-secondary buttons"
              title="Buscar Cliente"
              onClick={() => lookupCliente()}
              disabled={viewMode()}
            />

            <InputTextSp
              className={!viewMode() ? 'p-error' : ''}
              value={
                chamado.cliente?.nome
                  ? `${chamado.cliente?.numeroContrato} - ${chamado.cliente?.nome}`
                  : 'Selecione'
              }
              disabled
            />
          </div>
        </div>
        <div className="p-col-12 p-md-4 p-lg-4 p-fluid">
          <LabelSp>Contato</LabelSp>
          <InputTextSp
            ref={txtContatoRef}
            value={chamado.contato}
            disabled={viewMode()}
            maxLength={50}
            required
            onChange={e => {
              setChamado({ ...chamado, contato: e.target.value });
            }}
          />
        </div>

        <div className="p-col-12 p-md-3 p-lg-3 p-fluid">
          <LabelSp>Fone</LabelSp>
          <InputTextSp ref={txtContatoRef} value={clienteFone} disabled />
        </div>
        <div className="p-col-12 p-md-5 p-lg-5 p-fluid">
          <LabelSp>Celular</LabelSp>
          <InputTextSp ref={txtContatoRef} value={clienteCelular} disabled />
        </div>
        <div className="p-col-12 p-md-3 p-lg-3 p-fluid">
          <LabelSp>Chamado Transferência</LabelSp>
          <InputTextSp
            value={chamado.idChamado}
            disabled
            maxLength={7}
            required
            onChange={e => {
              setChamado({ ...chamado, contato: e.target.value });
            }}
          />
        </div>
        <div className="p-col-12 p-md-12 p-lg-12 p-fluid">
          <LabelSp>Classificação do Chamado</LabelSp>
          <div style={{ display: 'flex' }}>
            <ListBoxSp
              options={classificacoesSelecionadas}
              listStyle={{ maxHeight: '150px' }}
              required
              disabled={viewMode()}
              onChange={e => setClassificacaoSelecionada(e.value)}
              value={classificacaoSelecionada}
              optionLabel="descricao"
              optionValue="id"
              itemTemplate={option => {
                return (
                  <div>
                    <div className="marcador" />
                    <span>{option.descricao}</span>
                  </div>
                );
              }}
            />
            <div
              style={{
                marginLeft: 5,
                flex: 1,
              }}
            >
              <ButtonSp
                className="buttons"
                label=""
                disabled={viewMode()}
                icon="pi pi-plus-circle"
                title="Inserir"
                style={{ marginRight: 0 }}
                onClick={() => {
                  setLookupTopicoVisible(true);
                }}
              />
              <ButtonSp
                className="buttons p-button-warning"
                label=""
                icon="pi pi pi-pencil"
                title="Inserir"
                style={{ marginTop: 5, marginRight: 0 }}
                disabled={!classificacaoSelecionada || viewMode()}
                onClick={() => {
                  alteraDescricao();
                }}
              />
              <ButtonSp
                className="p-button-danger"
                label=""
                title="Excluir"
                icon="pi pi-trash"
                style={{ marginTop: 5, marginRight: 0 }}
                disabled={!classificacaoSelecionada || viewMode()}
                showConfirmation
                onClick={() => {
                  const indexOf = classificacoesSelecionadas.findIndex(
                    e => e.id === classificacaoSelecionada
                  );

                  if (indexOf >= 0) {
                    classificacoesSelecionadas.splice(indexOf, 1);
                    setClassificacoesSelecionadas([...classificacoesSelecionadas]);
                    setClassificacaoSelecionada(undefined);
                  }
                }}
              />
            </div>
          </div>
        </div>
        <div className="p-col-12 p-md-12 p-lg-12 p-fluid">
          <LabelSp>Descrição da Solicitação</LabelSp>
          <InputTextareaSp
            required
            autoResize={false}
            value={chamado.descricao}
            maxLength={2000}
            rows={3}
            resize={false}
            onChange={e => {
              setChamado({
                ...chamado,
                descricao: e.target.value,
              });
            }}
            disabled={viewMode()}
          />
        </div>
        <div className="p-col-12 p-md-12 p-lg-12 p-fluid">
          <LabelSp>Observação do Atendente</LabelSp>
          <InputTextareaSp
            required={chamado.status === 2 || chamado.status === 3}
            autoResize={false}
            value={chamado.observacaoAtendente}
            maxLength={2000}
            rows={3}
            resize={false}
            onChange={e => {
              setChamado({
                ...chamado,
                observacaoAtendente: e.target.value,
              });
            }}
            disabled={viewMode() || chamado.status === 0}
          />
        </div>
        <div className="p-col-12 p-lg-12" style={{ textAlign: 'start' }}>
          {!viewMode() ? (
            <ButtonSp
              className="p-button-success"
              icon="pi pi-save"
              label="Salvar"
              keyAccess="S"
              disabled={
                !validateFields(chamado, [
                  'dataLancamento',
                  'horaLancamento',
                  'idRevenda',
                  'idChamadoTipo',
                  'descricao',
                  'idCliente',
                  chamado.status !== 0 ? 'idColaborador' : '',
                  chamado.status === 2 ? 'horaFechamento' : '',
                  chamado.status === 2 ? 'dataFechamento' : '',
                  chamado.status === 2 || chamado.status === 3 ? 'observacaoAtendente' : '',
                ]) || classificacoesSelecionadas.length === 0
              }
              showConfirmation
              onClick={handleSave}
            />
          ) : null}
          {viewMode() ? (
            <ButtonSp
              className="p-button-primary"
              icon="pi pi-pencil"
              label="Alterar"
              disabled={!AuthService.checkRoles('CHAMADO_ALTERAR')}
              onClick={() => {
                if (
                  chamado &&
                  !AuthService.checkRoles(['CHAMADO_ALTERAR_OUTROS']) &&
                  AuthService.getUsuario().idColaborador &&
                  chamado.idColaborador &&
                  chamado.idColaborador !== AuthService.getUsuario().idColaborador
                ) {
                  toast.error(
                    'Você não tem permissão para alterar chamado de outro responsável'
                  );
                  return;
                }

                history.push(`/chamados/${idSelected}${uBack}`);
              }}
            />
          ) : null}
          <ButtonSp
            className={viewMode() ? 'p-button-secondary' : 'p-button-danger'}
            label={viewMode() ? 'Voltar' : 'Cancelar'}
            icon="pi pi-chevron-circle-left"
            onClick={handleBack}
          />
        </div>
      </>
    );
  };

  const renderArquivos = () => {
    return <CrudAnexo idSelected={idSelected} viewMode={viewMode} handleBack={handleBack} />;
  };

  const renderPaginaSelecionada = () => {
    if (paginaSelecionada === 0) {
      return renderCadastro();
    }

    return renderArquivos();
  };
  const buttons = ['Cadastro'];
  if (viewMode()) {
    buttons.push('Arquivos');
  }
  // render principal
  return (
    <>
      <div className="p-col-12 p-lg-12" style={{ padding: 0, margin: 0 }}>
        <SelectButtons
          widthButton={200}
          buttons={buttons}
          selectedIndex={paginaSelecionada}
          onClick={itemIndex => setPaginaSelecionada(itemIndex)}
        />
      </div>
      {renderPaginaSelecionada()}
    </>
  );
}

export default ChamadoCrud;
